import { round } from '@kunalabs-io/kai'

export const getPctValue = (value: number) => `${round(value * 100, 2) + '%'}`
